/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can switch between different prediction algorithms using the selector — each one weighs history differently. “Adaptive” is the default and works best for most situations.`)
};

const es_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes cambiar entre diferentes algoritmos de predicción — cada uno pondera el historial de forma diferente. «Adaptive» es el predeterminado y funciona mejor en la mayoría de situaciones.`)
};

const de_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst zwischen verschiedenen Vorhersage-Algorithmen wechseln — jeder gewichtet die Historie anders. „Adaptive“ ist die Standardeinstellung und funktioniert in den meisten Situationen am besten.`)
};

const nl_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt schakelen tussen verschillende voorspellingsalgoritmen — elk weegt de historie anders. "Adaptive" is de standaard en werkt het beste in de meeste situaties.`)
};

const fr_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez changer d’algorithme de prédiction — chacun pondère l’historique différemment. « Adaptive » est le choix par défaut et fonctionne le mieux dans la plupart des situations.`)
};

const it_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi cambiare tra diversi algoritmi di previsione — ognuno pesa la storia in modo diverso. «Adaptive» è l’impostazione predefinita e funziona meglio nella maggior parte delle situazioni.`)
};

const pt_br2_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode alternar entre diferentes algoritmos de previsão — cada um pesa o histórico de forma diferente. "Adaptive" é o padrão e funciona melhor na maioria das situações.`)
};

const pt_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode alternar entre diferentes algoritmos de previsão — cada um pondera o histórico de forma diferente. «Adaptive» é o predefinido e funciona melhor na maioria das situações.`)
};

const ja_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セレクターで異なる予測アルゴリズムを切り替えることができます。それぞれ履歴の重み付けが異なります。「Adaptive」がデフォルトで、ほとんどの状況で最適です。`)
};

const zh_f1_apex_how_p4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以切换不同的预测算法——每种算法对历史数据的权重不同。“Adaptive”是默认选项，适用于大多数情况。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_how_p4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_how_p4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_how_p4", locale)
	if (locale === "en") return en_f1_apex_how_p4(inputs)
	if (locale === "es") return es_f1_apex_how_p4(inputs)
	if (locale === "de") return de_f1_apex_how_p4(inputs)
	if (locale === "nl") return nl_f1_apex_how_p4(inputs)
	if (locale === "fr") return fr_f1_apex_how_p4(inputs)
	if (locale === "it") return it_f1_apex_how_p4(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_how_p4(inputs)
	if (locale === "pt") return pt_f1_apex_how_p4(inputs)
	if (locale === "ja") return ja_f1_apex_how_p4(inputs)
	return zh_f1_apex_how_p4(inputs)
};